import { select } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { LoggedUser } from '../core/logged/logged.model';

@Injectable({
  providedIn: 'root'
})
export class SuperadminUserGuard implements CanActivate {
  @select(['logged', 'logged'])
  loggedUser$: Observable<LoggedUser>;

  constructor(private router: Router) {}
  canActivate(): Observable<boolean> {
    return this.loggedUser$.pipe(
      first(),
      map((user: LoggedUser) => !!user && user?.token && user?.auth_user === 'superadmin'),
      tap(isSuperAdmin => {
        if (!isSuperAdmin) {
          console.error('Non sei autorizzato a visualizzare la pagina selezionata');
          this.router.navigate(['/home']);
        }
      })
    );
  }
}
